import React, { useRef, useState, useEffect } from "react";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./HorizontalScroller.scss";

export default function HorizontalScroller({ children, ...restProps }) {
  const store = useDtfStore();
  const scrollerRef = useRef(null);
  const [scrollState, setScrollState] = useState({
    canScrollLeft: false,
    canScrollRight: false
  });

  function isStandardArtwork() {
    return store.isStandardArtwork;
  }

  function canScrollLeft() {
    return scrollState.canScrollLeft;
  }

  function canScrollRight() {
    return scrollState.canScrollRight;
  }

  function checkScrollState() {
    if (!scrollerRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollerRef.current;
    setScrollState({
      canScrollLeft: scrollLeft - 30 > 0,
      canScrollRight: scrollLeft + clientWidth + 30 < scrollWidth
    });
  }

  function scroll(direction) {
    if (!scrollerRef.current) return;
    const multiplier = direction === "left" ? -1 : 1;
    scrollerRef.current.scrollBy({
      left: multiplier * scrollerRef.current.clientWidth,
      behavior: "smooth"
    });
  }

  useEffect(() => {
    queueMicrotask(() => {
      checkScrollState();
    });
    window.addEventListener("resize", checkScrollState);
    return () => {
      window.removeEventListener("resize", checkScrollState);
    };
  }, []);

  return (
    <div {...restProps} className={cn("horizontal-scroller scope-fecf2a37", restProps.className)}>
      {canScrollLeft() ? (
        <button
          className="horizontal-scroller__scroll-arrow horizontal-scroller__scroll-arrow--left scope-fecf2a37"
          type="button"
          onClick={() => {
            scroll("left");
          }}
          data-testid="horizontal-scroller-scroll-arrow"
        >
          <UseSvg
            className={cn("horizontal-scroller__scroll-arrow-icon scope-fecf2a37", {
              "horizontal-scroller__scroll-arrow-icon--standard-artwork": isStandardArtwork()
            })}
            icon="arrow-left"
            data-testid="horizontal-scroller-scroll-arrow-icon"
          />
        </button>
      ) : null}
      <div
        className="horizontal-scroller__scroller scope-fecf2a37"
        ref={scrollerRef}
        onScroll={checkScrollState}
        data-testid="horizontal-scroller-scroller"
      >
        {children}
      </div>
      {canScrollRight() ? (
        <button
          className="horizontal-scroller__scroll-arrow horizontal-scroller__scroll-arrow--right scope-fecf2a37"
          type="button"
          onClick={() => {
            scroll("right");
          }}
          data-testid="horizontal-scroller-scroll-arrow-1"
        >
          <UseSvg
            className={cn("horizontal-scroller__scroll-arrow-icon scope-fecf2a37", {
              "horizontal-scroller__scroll-arrow-icon--standard-artwork": isStandardArtwork()
            })}
            icon="arrow-right"
            data-testid="horizontal-scroller-scroll-arrow-icon-1"
          />
        </button>
      ) : null}
    </div>
  );
}
